<template>
    <div class="chart" ref="chart"></div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    /* Chart code */
    // Themes begin
    //am4core.useTheme(am4themes_animated);

    export default {

        components: {},

        props: {
            chartData: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                chart: null
            }
        },

        watch: {
            chartData(newData) {
                this.chart.data = newData;
            }
        },

        mounted() {
            this.buildChart();
        },

        methods: {

            buildChart() {
                this.chart = am4core.create(this.$refs.chart, am4charts.XYChart);

                // Use only absolute numbers
                this.chart.numberFormatter.numberFormat = "#.#s";

                this.chart.colors.list = [
                    am4core.color("#0277BD"),
                    am4core.color("#78909C"),
                    am4core.color("#999"),
                    am4core.color("#388E3C"),
                    am4core.color("#1976D2"),
                    am4core.color("#F9F871")
                ];

                // Create axes
                let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "name";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.inversed = true;

                let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.extraMin = 0.1;
                valueAxis.extraMax = 0.1;
                valueAxis.renderer.minGridDistance = 40;
                valueAxis.renderer.ticks.template.length = 10;
                valueAxis.renderer.ticks.template.disabled = false;
                //valueAxis.renderer.ticks.template.strokeOpacity = 0.4;
                valueAxis.renderer.labels.template.adapter.add("text", function (text) {
                    return text == "Male" || text == "Female" ? text : text + "%";
                });

                // Create series
                let male = this.chart.series.push(new am4charts.ColumnSeries());
                male.dataFields.valueX = "malePercent";
                male.dataFields.categoryY = "name";
                male.clustered = false;
                male.strokeWidth = 1;
                male.fillOpacity = 0.6;
                male.columns.template.tooltipText = "Males {name} - {malePercent}% ({maleCount})";
                male.showOnInit = false;

                let female = this.chart.series.push(new am4charts.ColumnSeries());
                female.dataFields.valueX = "femalePercent";
                female.dataFields.categoryY = "name";
                female.clustered = false;
                female.strokeWidth = 1;
                female.fillOpacity = 0.6;
                female.columns.template.tooltipText = "Females {name} - {femalePercent}% ({femaleCount})";
                female.showOnInit = false;

                this.chart.data = this.chartData;
            }
        }
    }
</script>

<style scoped>
    .chart {
        width: 100%;
        height: 350px;
    }
</style>
